export const roomConnectionStates = {
    CONNECTED: 'connected',
    DISCONNECTED: 'disconnected',
    RECONNECTING: 'reconnecting',
}

export const roomTypes = Object.freeze({
    OPEN_ROOM: 'OPEN_ROOM',
    GROUP_STUDY: 'GROUP_STUDY',
})
